import Swal from 'sweetalert2';
import api from '../../utils/axios';
import { useState, useCallback } from 'react';

interface SucursalItem {
  Id: number;
  IdEmpresa: number;
  Nombre: string;
  Telefono: string;
  Direccion: string;
  Target: number;
  Activo: boolean;
  Eliminado: boolean;
  empresa?: {
    Id: number;
    Nombre: string;
    Activo: boolean;
    Eliminado: boolean;
  };
}

interface SucursalDto {
  IdEmpresa: number;
  Nombre: string;
  Telefono: string;
  Direccion: string;
  Target: number;
  Activo: boolean;
  Eliminado: boolean;
}

interface ApiError {
  response?: {
    data?: {
      message?: string;
    };
  };
  message: string;
}

const useSucursalesApi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const baseUrl = '/administracion/sucursales';

  const getAll = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.post<SucursalItem[]>(`${baseUrl}/findAll`);
      const data = response.data.filter(item => !item.Eliminado).map(item => ({
        ...item,
        Target: item.Target ? parseFloat(String(item.Target)) : 0
      }));
      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const create = useCallback(async (data: SucursalDto) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/create`, {
        ...data,
        Target: parseFloat(String(data.Target)) || 0,
        Eliminado: false
      });
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const update = useCallback(async (id: number, data: SucursalDto) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/update/${id}`, {
        ...data,
        Target: Number(data.Target) || 0
      });
      return response.data;
    } catch (err) {
      const error = err as ApiError;
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const remove = useCallback(async (id: number) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/softDelete/${id}`);
      await Swal.fire({
        title: 'Éxito',
        text: 'La sucursal ha sido eliminada correctamente.',
        icon: 'success',
        confirmButtonText: 'OK'
      });
      return true;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    getAll,
    create,
    update,
    remove
  };
};

export { useSucursalesApi };
export type { SucursalItem, SucursalDto, ApiError };